/* @flow */

// Get the number value of the specified shorthand unit.
function getUnit(string: string, unit: string): number {
  return Number.parseInt(
    (string.match(new RegExp('[0-9]+' + unit)) || ['0']).pop()
  );
}

// Convert YouTube shorthand time to seconds.
export default function(time: ?(string | number)): number {
  const stringTime: string = String(time);

  if (/^[0-9]+$/.test(stringTime)) {
    return Number.parseInt(stringTime);
  }

  return getUnit(stringTime, 's')
    + getUnit(stringTime, 'm') * 60
    + getUnit(stringTime, 'h') * 3600;
}



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/utilities/shorthandToSeconds.js